import { render, staticRenderFns } from "./coursePPT.vue?vue&type=template&id=9a60acb0&scoped=true"
import script from "./coursePPT.vue?vue&type=script&lang=js"
export * from "./coursePPT.vue?vue&type=script&lang=js"
import style0 from "./coursePPT.vue?vue&type=style&index=0&id=9a60acb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60acb0",
  null
  
)

export default component.exports